import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=454817a8&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"
import style0 from "./Approval.vue?vue&type=style&index=0&id=454817a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454817a8",
  null
  
)

export default component.exports